'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var material = require('@mui/material');
var generatedCraftcms = require('@liquorice/generated-craftcms');
var createFieldControl = require('../lib/form/createFieldControl.js');
var FormieNestedRows = require('./FormieNestedRows/FormieNestedRows.js');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const FIELD_ADDRESS_FRAGMENT = generatedCraftcms.gql(`
  fragment fieldAddress on Field_Address {
    __typename
    ...fieldBase
    nestedRows {
      __typename
      ...formieNestedRow
    }
  }
`);
const Field_Address = createFieldControl.createField(FIELD_ADDRESS_FRAGMENT, (field, props)=>{
    const { nestedRows, handle, label, instructions, labelPosition } = field;
    return /*#__PURE__*/ jsxRuntime.jsxs(material.FormControl, {
        fullWidth: true,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx(material.Typography, {
                component: "legend",
                sx: {
                    mb: 2
                },
                hidden: labelPosition === 'hidden',
                children: label
            }),
            instructions && /*#__PURE__*/ jsxRuntime.jsx(material.FormHelperText, {
                children: instructions
            }),
            /*#__PURE__*/ jsxRuntime.jsx(FormieNestedRows, _extends({
                data: nestedRows,
                parentHandle: handle
            }, props))
        ]
    });
});

exports.FIELD_ADDRESS_FRAGMENT = FIELD_ADDRESS_FRAGMENT;
exports.Field_Address = Field_Address;
